// tslint:disable:object-literal-key-quotes
// tslint:disable:object-literal-sort-keys
import { CSSProperties, StyleDeclaration, StyleDeclarationMap, StyleSheet } from 'aphrodite';
import { brandSecondary } from './colors';

export const BreakPoints = {
	forMaxWith: (maxWidth: number) => `@media only screen and (max-width: ${ maxWidth }px)`,
	forMinWith: (minWidth: number) => `@media only screen and (min-width: ${ minWidth }px)`,
	phoneCompactWidth: '@media only screen and (max-width: 420px)',
	tabletCompactHeight: '@media only screen and (max-height: 768px)',
	tabletCompactWidth: '@media only screen and (max-width: 768px)',
	tabletHeight: '@media only screen and (max-height: 1024px)',
	tabletWidth: '@media only screen and (max-width: 1024px)',
};

export const ctaButtonBase: CSSProperties = {
	background: brandSecondary,
	border: 'none',
	borderRadius: 3,
	boxShadow: '0 1px 2px 0 rgba(140,140,140,0.50)',
	color: '#fff',
	display: 'flex',
	fontSize: 14,
	justifyContent: 'center',
	textAlign: 'center',
};

export const baseStyles: StyleDeclaration<{
	brandLink: CSSProperties | StyleDeclarationMap,
	ctaButton: CSSProperties | StyleDeclarationMap,
	ctaButtonSmall: CSSProperties | StyleDeclarationMap,
	defaultNotFirstChildLeftSpacing: CSSProperties | StyleDeclarationMap,
	link: CSSProperties | StyleDeclarationMap,
	minorActionLink: CSSProperties | StyleDeclarationMap,
	truncateText: CSSProperties | StyleDeclarationMap,
}> = {
	brandLink: {
		fontSize: 14,
		color: brandSecondary,
	},
	ctaButton: {
		...ctaButtonBase,
		minWidth: 90,
		padding: '10px 20px',
	},
	ctaButtonSmall: {
		...ctaButtonBase,
		minWidth: 60,
		padding: '4px 14px',
	},
	defaultNotFirstChildLeftSpacing: {
	},
	link: {
		fontSize: 14,
		color: '#767676',
	},
	minorActionLink: {
		fontSize: 12,
		color: '#8E8E8E',
	},
	truncateText: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
};

export const CssSelectors = {
	allChildren: (style: CSSProperties, filter?: string) => {
		const result: StyleDeclaration = {};
		if (!style) {
			return result;
		}

		const mFilter = sanitizeFilter(filter);
		return CssSelectors.allDescendants(style, `> ${ mFilter }`);
	},
	allDescendants: (style: CSSProperties, filter?: string) => {
		const result: StyleDeclaration = {};
		if (!style) {
			return result;
		}

		const mFilter = sanitizeFilter(filter);
		(result as any)[`:nth-child(1n) ${ mFilter }`] = style;
		return result;
	},
};

const sanitizeFilter = (filter?: string) => {
	let mFilter = !!filter ? filter : '*';
	const firstChar = mFilter.charAt(0);
	if (firstChar === ':') {
		// prefix with wildcard
		mFilter = `*${ mFilter }`;
	}
	return mFilter;
};

export const baseStyleSheet = StyleSheet.create(baseStyles);
